import moment from 'moment'

moment.updateLocale('en', {
    week: {
        dow: 1,
    },
})

const utcOffset = 0

// TODO: It looks like this is not needed however there may be a deeper cause to how we handle
// GMT time currently a the instnace level in php
// if (window.WP_CONFIG && window.WP_CONFIG.properties && window.WP_CONFIG.properties.utcOffset ) {
//     utcOffset = window.WP_CONFIG.properties.utcOffset
// }

function momentTimeZone(...args) {
    return moment.call(null, ...args).utcOffset(utcOffset, false)
}

momentTimeZone.unix = function(unixtime) {
    return moment.unix(unixtime).utcOffset(utcOffset, false)
}

momentTimeZone.utcUnix = function(unixtime) {
    return moment.unix(unixtime)
}

export default momentTimeZone





// WEBPACK FOOTER //
// ./src/whatson/utils/momentTimeZone.js